<template>
  <div class="dashboard__row"
    v-if="videos.length > 0 || hasAddButton"
  >
    <h2>{{ title }}</h2>
    <h4 v-if="hasPendingWarning">Our review period requires a minimum of 2 weeks.</h4>
    <el-row :gutter="16">
      <CardCol
        v-for="video in videos"
        :key="video.id"
      >
        <DashboardItem :video="video"/>
      </CardCol>
      <CardCol v-if="hasAddButton">
        <DashboardAddButton/>
      </CardCol>
      
    </el-row>
  </div>
</template>

<script>
import CardCol from '@/components/Shared/CardCol';
import DashboardItem from './ListItem';
import DashboardAddButton from './ListItemAddButton';

export default {
  components: {
    DashboardAddButton,
    DashboardItem,
    CardCol,
  },
  props: {
    videos: {
      type: Array,
      required: true,
    },
    title: {
      type: String,
      default: null,
    },
    hasAddButton: {
      type: Boolean,
      default: false,
    },
    hasPendingWarning: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss">
.dashboard__row {
  border-bottom: 1px solid rgba(0,0,0,0.1);
  padding-bottom: 3em;
  margin-bottom: 3em;
}
.dashboard__row:last-of-type {
  border-bottom: none;
  padding-top: 0;
  margin-top: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/ListRow.vue